<script>
import {Calendar} from 'v-calendar'
import 'v-calendar/dist/style.css'

export default {
    name: "EventsCalendarApp",

    props: {
        dates: {
            type: Array,
            default: () => [],
        }
    },

    components: {
        Calendar,
    },

    data() {},

    computed: {
        attributes() {
            return [
                ...this.dates.map(event => ({
                    dates: event.date,
                    highlight: {
                        style: {
                            background: '#b69a83'
                        },
                    },
                    popover: {
                        label: event.title,
                        hideIndicator: true
                    },
                })),
            ]
        },
    },
}
</script>
<template>
    <Calendar :attributes='attributes' :min-date="new Date()" />
</template>
<style lang="scss">
    @import "../../define/variables";

    .calendar-app {
        margin: 1rem 0;
    }

    .vc {
        &-container {
            border: none;
            color: white;
            width: 100%;
        }

        &-header {
            background: $c_primary_darkest;
            padding: 10px;
        }

        &-weeks {
            background: $c_primary;
        }

        &-header {
            .vc-title {
                text-transform: uppercase;
                color: black;
                font-weight: bold;
                font-size: 1rem;
                position: relative;
            }
        }

        &-svg-icon {
            color: white;
            width: 2rem;
            height: 100%;
        }

        &-arrow {
            border: none;
            color: white;
            width: auto;
            padding: 0;

            svg {
                width: 30px;
                height: 30px;
            }

            &:hover {
                background: $c_primary;
            }
        }

        &-weekday {
            color: black;
        }
    }
</style>
